module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//red_2.png?v=b794d67b";